import { useContext } from 'react';
import FeatureTogglesContext from '@/contexts/feature-toggles-local-storage';

const useABFeaturesFromLocalStorage = () => {
  return useContext(FeatureTogglesContext);
};

export default useABFeaturesFromLocalStorage;